import RefreshCheckApi from '../../../communication_system/axios_apis/refresh_check/refresh_check_api';

export const searchUsers = async (keyword) => {
    try {
        const response = await RefreshCheckApi.get('/adminUser', {
            params: {
                page: 1,
                size: 20,
                searchType: 1,
                searchWord: keyword?.replaceAll('-', ''),
            },
        });

        return response?.data?.data || [];
    } catch (err) {
        return [];
    }
};

export const testRecommendPrompt = async (payload) => {
    try {
        const response = await RefreshCheckApi.post('/ai/recommend/prompt', payload);
        return response?.data;
    } catch (err) {
        return {
            ok: false,
            status: err?.response?.status || 500,
            message: err?.response?.data?.message || '서버 에러',
        };
    }
};
